const GA_ID = "G-SLP9S4QJ3K";

// Custom events: itinerary_generated, trip_saved, trip_shared, enquiry_submitted, checkout_started, order_paid
// (order_paid fires from the checkout success page once payments are wired; call track("order_paid", {value, currency:"AUD", plan}).)

export const EU_TZ = /^(Europe\/|Atlantic\/(Azores|Madeira|Canary|Faroe|Reykjavik)|GB|Eire)/;
export const isEuVisitor = () => {
  try { return EU_TZ.test(Intl.DateTimeFormat().resolvedOptions().timeZone || ""); } catch { return false; }
};
export const getConsent = () => { try { return localStorage.getItem("wm_consent"); } catch { return null; } };

export const setConsent = (value) => {
  try { localStorage.setItem("wm_consent", value); } catch {}
  window[`ga-disable-${GA_ID}`] = value !== "accepted";
  if (value === "accepted" && window.gtag) {
    window.gtag("consent", "update", { analytics_storage: "granted" });
    window.gtag("config", GA_ID);
  }
};

export const analyticsAllowed = () => !(isEuVisitor() && getConsent() !== "accepted") && getConsent() !== "declined";

export const track = (event, params = {}) => {
  if (!analyticsAllowed() || typeof window.gtag !== "function") return;
  window.gtag("event", event, params);
};
